<mat-toolbar class="header-toolbar">
  <div class="header-container">
    <div class="logo-section">
      <mat-icon class="logo-icon">school</mat-icon>
      <span class="logo-text">KNT <span class="accent">ERP</span></span>
    </div>

    <div class="nav-links">
      <a mat-button routerLink="/">Home</a>
      <a mat-button routerLink="/about">About</a>
      <a mat-button routerLink="/our-services">Services</a>
      <a mat-button routerLink="/support">Support</a>
    </div>

    <div class="actions">
      <button mat-flat-button color="primary" routerLink="/auth/login" class="login-btn">
        <mat-icon>login</mat-icon>
        Login
      </button>
    </div>
  </div>
</mat-toolbar>